export default __webpack_public_path__ + "static/media/mt_ln_2.86264068.png";